module.exports = "/_next/static/pages/test-guidelines/de71a5ce7dd15700601fe187890c97c1.png";